/**
* @ngdoc component
* @name common.address.component:itxAddressZipcode
* @description
* Component description
* @param {object} model Address model
* @param {object} form form
* @param {string} class classes for the cointaner component. Example: col-xs-12
*/
(function() {
    'use strict';

    var itxAddressZipcode = {
        bindings: {
            model:'=',
            form:'=',
            class:'<',
            store:'<',
            isBilling:'<',
            regex:'<', 
            require:'<'
        },
        controller:   itxAddressZipcodeCtrl,
        templateUrl: 'address-zipcode.component.html'
    };

    itxAddressZipcodeCtrl.$inject = [
        'ItxTranslateSvc'
    ];

    function itxAddressZipcodeCtrl (
        ItxTranslateSvc
    ) {
        var _this = this;
        _this.regexZipCode = '';

        _this.$onInit = function(){
            _this.regexZipCode = _this.regex;
        };

        _this.$onChanges = function () {
            if(!inditex.iStoreId){
                console.error('itx-address-zipcode Required param  is undefined: No store in zipcode component params');
            }
           
            _this.errorText = ItxTranslateSvc.translate('Messages_zipCode', _this.model.countryCode, 'isZipCode')
            _this.regexZipCode = _this.regex;
        };
    }

    angular.module('itxApp.legacy')
    .component('itxAddressZipcode',itxAddressZipcode);

})();
